// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lJg39wvWUaY47THcJETw{flex-direction:column;gap:42px;display:flex}.R8YlI7CWFEMr1B_4LxHQ{justify-content:space-between;align-items:center;margin-bottom:16px;display:flex}.hjieqVNhSA009o3Sl8iW,.q_qjSh_Cnr0aHKU_pvdh{align-items:center;gap:8px;display:flex}.VXhQFIiodxQwRsHHOr52{align-items:center;display:flex}.Em3rxod48DQ870XoI9p9{flex-direction:column;gap:6px;margin-left:16px;display:flex}.olSGuchu0k3Sp6h2Pble{line-height:16px}.vnSx9FnCs6s9Yc3J8Kcd{height:32px;margin-left:auto}.RgMRJ5tyAh4FgHCmO0gL{background:var(--light-blue-10);border-radius:6px;height:36px;padding:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"manageContainer": `lJg39wvWUaY47THcJETw`,
	"manageHeader": `R8YlI7CWFEMr1B_4LxHQ`,
	"leftContent": `hjieqVNhSA009o3Sl8iW`,
	"rightContent": `q_qjSh_Cnr0aHKU_pvdh`,
	"manageInfoLine": `VXhQFIiodxQwRsHHOr52`,
	"manageInfoLineContent": `Em3rxod48DQ870XoI9p9`,
	"manageInfoLineLabel": `olSGuchu0k3Sp6h2Pble`,
	"manageInfoLineButton": `vnSx9FnCs6s9Yc3J8Kcd`,
	"manageInfoLineIconWrap": `RgMRJ5tyAh4FgHCmO0gL`
};
export default ___CSS_LOADER_EXPORT___;
